/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Bezpečná platba`
};

const da_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Sikker betaling`
};

const de_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Sichere Zahlung`
};

const en_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Securized payment`
};

const es_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pago seguro`
};

const fr_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Paiement sécurisé`
};

const hu_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Biztonságos fizetés`
};

const it_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pagamento sicuro`
};

const nl_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Veilig betalen`
};

const pl_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Bezpieczna płatność`
};

const pt_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Pagamento seguro`
};

const sv_reinsurances_safe_payment = /** @type {(inputs: {}) => string} */ () => {
	return `Säker betalning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_safe_payment = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_safe_payment(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_safe_payment", locale)
	if (locale === "cs") return cs_reinsurances_safe_payment(inputs)
	if (locale === "da") return da_reinsurances_safe_payment(inputs)
	if (locale === "de") return de_reinsurances_safe_payment(inputs)
	if (locale === "en") return en_reinsurances_safe_payment(inputs)
	if (locale === "es") return es_reinsurances_safe_payment(inputs)
	if (locale === "fr") return fr_reinsurances_safe_payment(inputs)
	if (locale === "hu") return hu_reinsurances_safe_payment(inputs)
	if (locale === "it") return it_reinsurances_safe_payment(inputs)
	if (locale === "nl") return nl_reinsurances_safe_payment(inputs)
	if (locale === "pl") return pl_reinsurances_safe_payment(inputs)
	if (locale === "pt") return pt_reinsurances_safe_payment(inputs)
	return sv_reinsurances_safe_payment(inputs)
};
export { reinsurances_safe_payment as "reinsurances.safe_payment" }